export default {
  path: '/generalAccounting',
  component: () => import('@/components/home.vue'),
  children: [
    {
      path: 'queryCurrencies',
      name: 'queryCurrencies',
      component: () =>
        import('@/pages/financeCenter/generalAccounting/currency/queryCurrencies.vue'),
      meta: {
        keepAlive: true,
        title: '查询币种',
      },
    },
    {
      path: 'addCurrencies',
      name: 'addCurrencies',
      component: () => import('@/pages/financeCenter/generalAccounting/currency/addCurrencies.vue'),
      meta: {
        keepAlive: true,
        title: '币种维护',
      },
    },
    {
      path: 'searchCalendar',
      name: 'searchCalendar',
      component: () =>
        import('@/pages/financeCenter/generalAccounting/calendar/searchCalendar.vue'),
      meta: {
        keepAlive: true,
        title: '查询日历',
      },
    },
    {
      path: 'creatCalendar',
      name: 'creatCalendar',
      component: () => import('@/pages/financeCenter/generalAccounting/calendar/creatCalendar.vue'),
      meta: {
        keepAlive: true,
        title: '日历创建',
      },
    },
    {
      path: 'calendarView',
      name: 'calendarView',
      component: () => import('@/pages/financeCenter/generalAccounting/calendar/calendarView.vue'),
      meta: {
        keepAlive: true,
        title: '日历详情',
      },
    },
    {
      path: 'exchangeRate',
      name: 'exchangeRate',
      component: () =>
        import('@/pages/financeCenter/generalAccounting/exchangerate/exchangerate.vue'),
      meta: {
        keepAlive: true,
        title: '汇率查询',
      },
    },
    {
      path: 'exchangerateMaintain',
      name: 'exchangerateMaintain',
      component: () =>
        import('@/pages/financeCenter/generalAccounting/exchangerate/exchangerateMaintain.vue'),
      meta: {
        keepAlive: true,
        title: '汇率维护',
      },
    },
    {
      path: 'queryVoucher',
      name: 'queryVoucher',
      component: () => import('@/pages/financeCenter/generalAccounting/voucher/queryVoucher.vue'),
      meta: {
        keepAlive: true,
        title: '查询凭证',
      },
    },
    {
      path: 'addVoucher',
      name: 'addVoucher',
      component: () => import('@/pages/financeCenter/generalAccounting/voucher/addVoucher.vue'),
      meta: {
        keepAlive: true,
        title: '凭证录入',
      },
    },
    {
      path: 'editVoucher',
      name: 'editVoucher',
      component: () => import('@/pages/financeCenter/generalAccounting/voucher/editVoucher.vue'),
      meta: {
        keepAlive: true,
        title: '编辑凭证',
      },
    },
    {
      path: 'detailVoucher',
      name: 'detailVoucher',
      component: () => import('@/pages/financeCenter/generalAccounting/voucher/detailVoucher.vue'),
      meta: {
        keepAlive: true,
        title: '凭证详情',
      },
    },
    {
      path: 'periodManage',
      name: 'periodManage',
      component: () => import('@/pages/financeCenter/generalAccounting/periodManage/index.vue'),
      meta: {
        keepAlive: true,
        title: '期间管理',
      },
    },
    // {
    //   path: 'periodManage',
    //   name: 'periodManage',
    //   component: periodManage,
    //   meta: {
    //     keepAlive: true,
    //     title: '期间管理',
    //   },
    // },
    /**凭证引擎**/
    {
      path: 'queryAeEvent',
      name: 'queryAeEvent',
      component: () => import('@/pages/financeCenter/generalAccounting/aeEvent/list.vue'),
      meta: {
        keepAlive: true,
        title: '事件分类',
      },
    },
    {
      path: 'editAeEvent',
      name: 'editAeEvent',
      component: () => import('@/pages/financeCenter/generalAccounting/aeEvent/edit.vue'),
      meta: {
        keepAlive: true,
        title: '事件编辑',
      },
    },
    {
      path: 'queryVoucherTemplate',
      name: 'queryVoucherTemplate',
      component: () => import('@/pages/financeCenter/generalAccounting/aeVoucherTemplate/list.vue'),
      meta: {
        keepAlive: true,
        title: '凭证模板',
      },
    },
    {
      path: 'editVoucherTemplate',
      name: 'editVoucherTemplate',
      component: () => import('@/pages/financeCenter/generalAccounting/aeVoucherTemplate/edit.vue'),
      meta: {
        keepAlive: true,
        title: '凭证模板编辑',
      },
    },
  ],
};
